<template>
    <div>

   <mainform-widget v-if="zeigeSuchfeld" ref="mainformWidget" class=""></mainform-widget>

        <!-- Head -->


        <!-- Default Site Start -->
        <div v-if="sf1 == 0 && sf2 == 0" >

           <FirmaDetailDaten @mysuchmusterevent="mysuchmusterMeth"></FirmaDetailDaten>


        </div>

        <!-- Default Site End -->

        <!-- Branchen Hits Start -->
        <p   v-else-if="sf1 == 1 && sf2 == 0" >
            <vue-progress-bar></vue-progress-bar>
            <ResultsSf1 v-bind:suchmuster="suchmuster"></ResultsSf1>
        </p>
        <!-- Branchen Hits End -->

        <!-- Firmen Hits Start -->
        <p  v-else-if="sf1 == 0 && sf2 == 1" >
            <vue-progress-bar></vue-progress-bar>
            <ResultsSf2 v-bind:suchmuster="suchmuster"></ResultsSf2>

        </p>
        <!-- Firmen Hits End -->

        <!-- Branchen und Firmen Start -->
        <p  v-else="sf1 == 1 && sf2 == 1" >
            Zeige die Branchen und Firmen treffer

        </p>
        <!-- Branchen und Firmen End -->

        <!-- Default Site End -->
        <!-- Head Ende -->
    </div>
</template>
<script>

    //import mainformWidget from '/Users/dieterdeutsch/Web/Projects/hausbaufuehrer1/resources/js/components/mainsuche/mainformWidget.vue';
    import mainformWidget from '../../../../resources/js/components/suchfilter/mainformWidget.vue';
    import ResultsSf1 from '../../../../resources/js/components/suchfilter/ResultsSf1.vue';
    import ResultsSf2 from '../../../../resources/js/components/suchfilter/ResultsSf2.vue';
    import WerbeBannerNationalWidget from '../../components/banner/WerbebannerNationalWidget.vue';
    import ImFocusBanner from '../../components/banner/ImFocusBanner';
    import FirmaDetailDaten from '../../components/firma/FirmaDetailDaten';
       export default {
             components:{ResultsSf1,ResultsSf2,mainformWidget,WerbeBannerNationalWidget,ImFocusBanner,FirmaDetailDaten},
        //name: "startseite",
        //props: ['slug'],
           data () {
               return {
                   sf1: 0,
                   sf2: 0,
                   slug: this.$attrs.slug, // holt sich den Wert von Module Firma Controller FirmaController  public function show($slug)
                   suchmuster: '',
                   zeigeSuchfeld: false,



               }
           },

           methods: {

               mysuchmusterMeth(mytest){
                   console.log('bin in mysuchmuster', mytest);
               },

               showSuchfeld: function (event) {
                   // `this` inside methods point to the Vue instance
                   alert('ZeigeSuchfeld')
                   // `event` is the native DOM event
                   //alert(event.target.tagName)
               }
           },

           created() {
               Fire.$on('setSf1',(data) => {
                   this.sf1 = data;
               })
               Fire.$on('setSf2',(data) => {
                   this.sf2 = data;
               })
               Fire.$on('setSuchmuster',(data) => {
                   this.suchmuster = data;
               })

               Fire.$on('zeigeSuchform',(data) => {
                   this.zeigeSuchfeld = data;
               })


           },



           mounted() {

            //console.log('bin in detailseite:', this.$props.slug);
             //this.sf1 =  this.$refs.mainformWidget.$refs.sf1.$data.sf1;

            // console.log('bin in startseite ',this.$refs.mainformWidget.$refs.sf1.$data.sf1);
            //this.sf1 = this.$options.name.Sf1.sf1;
           }
       }
</script>

